(function () {
  function initSliders() {
    document.querySelectorAll('.section-product-slider-container').forEach(container => {
      if (container.dataset.sliderInit) return;

      const slider = container.querySelector('.product-slider');
      const nextBtn = [...container.querySelectorAll('.slider-desk .button-next, .slider-mobile .button-next')];
      const prevBtn = [...container.querySelectorAll('.slider-desk .button-prev, .slider-mobile .button-prev')];
      const pagination = container.querySelector('.swiper-pagination');

      if (!slider || !nextBtn || !prevBtn) return;

      container.dataset.sliderInit = 'true';

      new Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: 8,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
         pagination: {
          el: pagination,
          clickable: true
        },
      });
    });
  }

  const interval = setInterval(() => {
    initSliders();
    const allDone = [...document.querySelectorAll('.section-product-slider-container')]
      .every(c => c.dataset.sliderInit);
    if (allDone && document.querySelector('.section-product-slider-container')) {
      clearInterval(interval);
    }
  }, 300);
})();